import * as React from 'react';
import { AbstractFilterSectionView, FilterSectionViewProps } from '../AbstractFilterSectionView';

interface FilterViewProps extends FilterSectionViewProps {
}

export class TensionAccessoriesFilterView extends AbstractFilterSectionView<FilterViewProps> {
    public render() {
        return <div className="pf-filter-container"/>;
    }
}
